
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './EPICheck-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
              case 'pointercancel':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'es.cragma.epicheck.extractStringField' : (jsonString, key) => { try { const obj = JSON.parse(jsonString); return obj[key] || ''; } catch(e) { return ''; } },
    'es.cragma.epicheck.fetchGetJsonAuth' : (url, token) => window.fetch(url, { method: 'GET', headers: token ? {'Authorization': 'Bearer ' + token} : {} }).then(res => { if (!res.ok) return '[]'; return res.text(); }),
    'es.cragma.epicheck.extractUserName' : (jsonString) => { try { const obj = JSON.parse(jsonString); return obj.fields.name.stringValue; } catch(e) { return ''; } },
    'es.cragma.epicheck.extractUserRole' : (jsonString) => { try { const obj = JSON.parse(jsonString); return obj.fields.role.stringValue; } catch(e) { return 'Inspector/a'; } },
    'es.cragma.epicheck.extractUserCompanyIds' : (jsonString) => { try { const obj = JSON.parse(jsonString); return obj.fields.companyId ? [obj.fields.companyId.stringValue] : obj.fields.companyIds.arrayValue.values.map(v => v.stringValue); } catch(e) { return []; } },
    'es.cragma.epicheck.extractCompanyName' : (jsonString) => { try { const obj = JSON.parse(jsonString); return obj.fields.name.stringValue; } catch(e) { return ''; } },
    'es.cragma.epicheck.extractCompanyStringField' : (jsonString, field) => { try { const obj = JSON.parse(jsonString); return obj.fields[field] ? obj.fields[field].stringValue : ''; } catch(e) { return ''; } },
    'es.cragma.epicheck.extractCompanyPlan' : (jsonString) => { try { const obj = JSON.parse(jsonString); return obj.fields.planName ? obj.fields.planName.stringValue : 'Gratuito'; } catch(e) { return 'Gratuito'; } },
    'es.cragma.epicheck.extractCompanyIntField' : (jsonString, field) => { try { const obj = JSON.parse(jsonString); return obj.fields[field] ? parseInt(obj.fields[field].integerValue) : 0; } catch(e) { return 0; } },
    'es.cragma.epicheck.parseEquipmentsList' : (jsonString) => {
        try {
            const obj = JSON.parse(jsonString);
            if (Array.isArray(obj)) return obj.map(item => JSON.stringify(item));
            if (!obj.documents) return [];
            return obj.documents.map(doc => {
                const fields = doc.fields || {};
                const eqId = doc.name ? doc.name.split('/').pop() : '';
                return JSON.stringify({
                    id: eqId,
                    companyId: fields.companyId ? fields.companyId.stringValue : '',
                    name: fields.name ? fields.name.stringValue : '',
                    serialNumber: fields.serialNumber ? fields.serialNumber.stringValue : '',
                    category: fields.category ? fields.category.stringValue : 'General',
                    manufacturer: fields.manufacturer ? fields.manufacturer.stringValue : '',
                    model: fields.model ? fields.model.stringValue : '',
                    definition: fields.definition ? fields.definition.stringValue : '',
                    size: fields.size ? fields.size.stringValue : 'M',
                    uniqueCode: fields.uniqueCode ? fields.uniqueCode.stringValue : '',
                    digitalId: fields.digitalId ? fields.digitalId.stringValue : '',
                    productionDate: fields.productionDate ? fields.productionDate.stringValue : '',
                    firstUseDate: fields.firstUseDate ? fields.firstUseDate.stringValue : '',
                    assignedInspectionCompany: fields.assignedInspectionCompany ? fields.assignedInspectionCompany.stringValue : 'Próximamente',
                    inspector: fields.inspector ? fields.inspector.stringValue : '',
                    ownerCompany: fields.ownerCompany ? fields.ownerCompany.stringValue : '',
                    assignedWorker: fields.assignedWorker ? fields.assignedWorker.stringValue : '',
                    lastInspectionDate: fields.lastInspectionDate ? fields.lastInspectionDate.stringValue : 'Sin inspecciones',
                    nextInspectionDate: fields.nextInspectionDate ? fields.nextInspectionDate.stringValue : '',
                    inspectionId: fields.inspectionId ? fields.inspectionId.stringValue : 'N/A',
                    status: fields.status ? fields.status.stringValue : 'Correcto',
                    registrationDate: fields.registrationDate ? fields.registrationDate.stringValue : '05/10/2026',
                    imageUrl: fields.imageUrl ? fields.imageUrl.stringValue : ''
                });
            });
        } catch(e) {
            return [];
        }
    },
    'es.cragma.epicheck.jsExtractHistoryJson' : (jsonString) => {
        try {
            const obj = JSON.parse(jsonString);
            if (!obj.inspectionsHistory) return '[]';
            return JSON.stringify(obj.inspectionsHistory);
        } catch(e) {
            return '[]';
        }
    },
    'es.cragma.epicheck.parseCompaniesList' : (jsonString) => {
        try {
            const obj = JSON.parse(jsonString);
            if (!obj.documents) return [];
            return obj.documents.map(doc => {
                const fields = doc.fields || {};
                const compId = doc.name ? doc.name.split('/').pop() : '';
                return JSON.stringify({
                    id: compId,
                    name: fields.name ? fields.name.stringValue : '',
                    taxId: fields.taxId ? fields.taxId.stringValue : '',
                    fiscalAddress: fields.fiscalAddress ? fields.fiscalAddress.stringValue : '',
                    country: fields.country ? fields.country.stringValue : '',
                    province: fields.province ? fields.province.stringValue : '',
                    city: fields.city ? fields.city.stringValue : '',
                    sector: fields.sector ? fields.sector.stringValue : '',
                    planName: fields.planName ? fields.planName.stringValue : 'Estándar Pro',
                    maxItems: fields.maxItems ? parseInt(fields.maxItems.integerValue) : 100,
                    maxCompanies: fields.maxCompanies ? parseInt(fields.maxCompanies.integerValue) : 1,
                    allowCsvImport: fields.allowCsvImport ? fields.allowCsvImport.booleanValue : true
                });
            });
        } catch(e) {
            return [];
        }
    },
    'es.cragma.epicheck.extractCompanyBooleanField' : (jsonString, field) => { try { const obj = JSON.parse(jsonString); return obj[field] !== false; } catch(e) { return true; } },
    'es.cragma.epicheck.buildFirestoreCompanyPayload' : (compJsonStr) => {
        try {
            const comp = JSON.parse(compJsonStr);
            return JSON.stringify({
                fields: {
                    companyId: { stringValue: comp.id || '' },
                    name: { stringValue: comp.name || '' },
                    taxId: { stringValue: comp.taxId || '' },
                    fiscalAddress: { stringValue: comp.fiscalAddress || '' },
                    country: { stringValue: comp.country || 'España' },
                    province: { stringValue: comp.province || '' },
                    city: { stringValue: comp.city || '' },
                    sector: { stringValue: comp.sector || '' },
                    postalCode: { stringValue: comp.postalCode || '' },
                    phone: { stringValue: comp.phone || '' },
                    website: { stringValue: comp.website || '' },
                    planName: { stringValue: comp.planName || 'Estándar Pro' },
                    maxItems: { integerValue: comp.maxItems || 100 },
                    maxCompanies: { integerValue: comp.maxCompanies || 1 },
                    allowCsvImport: { booleanValue: comp.allowCsvImport !== false }
                }
            });
        } catch(e) {
            return '{}';
        }
    },
    'es.cragma.epicheck.downloadDataUrlWeb' : (dataUrl, fileName) => {
        try {
            var a = document.createElement('a');
            a.href = dataUrl;
            a.download = fileName || 'EPICheck_Inventario.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch(e) {
            window.open(dataUrl, '_blank');
        }
    },
    'es.cragma.epicheck.clearWasmLastImage' : () => { window.epicheckLastImage = ''; },
    'es.cragma.epicheck.triggerWasmImagePicker' : () => {
        try {
            window.epicheckLastImage = '';
            let input = document.getElementById('epicheck-image-file-input');
            if (!input) {
                input = document.createElement('input');
                input.id = 'epicheck-image-file-input';
                input.type = 'file';
                input.accept = 'image/*';
                input.style.position = 'fixed';
                input.style.opacity = '0';
                input.style.top = '-1000px';
                document.body.appendChild(input);
            }
            input.value = '';
            input.onchange = (e) => {
                const files = input.files;
                if (files && files.length > 0) {
                    const file = files[0];
                    const reader = new FileReader();
                    reader.onload = (evt) => {
                        const rawDataUrl = evt.target.result || '';
                        const img = new Image();
                        img.onload = () => {
                            const canvas = document.createElement('canvas');
                            let width = img.width;
                            let height = img.height;
                            const maxDim = 800;
                            if (width > maxDim || height > maxDim) {
                                if (width > height) {
                                    height = Math.round((height * maxDim) / width);
                                    width = maxDim;
                                } else {
                                    width = Math.round((width * maxDim) / height);
                                    height = maxDim;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0, width, height);

                            let quality = 0.85;
                            let dataUrl = canvas.toDataURL('image/jpeg', quality);
                            while (dataUrl.length > 130000 && quality > 0.1) {
                                quality -= 0.1;
                                dataUrl = canvas.toDataURL('image/jpeg', quality);
                            }
                            window.epicheckLastImage = dataUrl;
                        };
                        img.src = rawDataUrl;
                    };
                    reader.readAsDataURL(file);
                }
            };
            input.click();
        } catch(e) {
            console.error(e);
        }
    },
    'es.cragma.epicheck.getWasmLastImage' : () => window.epicheckLastImage || '',
    'es.cragma.epicheck.clearWasmLastCsv' : () => { window.epicheckLastCsvName = ''; window.epicheckLastCsvContent = ''; },
    'es.cragma.epicheck.triggerWasmCsvFilePicker' : () => {
        try {
            window.epicheckLastCsvName = '';
            window.epicheckLastCsvContent = '';
            let input = document.getElementById('epicheck-csv-file-input');
            if (!input) {
                input = document.createElement('input');
                input.id = 'epicheck-csv-file-input';
                input.type = 'file';
                input.accept = '.csv,.xlsx,.xls,.tsv,text/csv,text/plain,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel';
                input.style.position = 'fixed';
                input.style.opacity = '0';
                input.style.top = '-1000px';
                document.body.appendChild(input);
            }
            input.value = '';
            input.onchange = (e) => {
                const files = input.files;
                if (files && files.length > 0) {
                    const file = files[0];
                    const fileName = file.name || 'archivo.csv';
                    const lowerName = fileName.toLowerCase();
                    const isExcel = lowerName.endsWith('.xlsx') || lowerName.endsWith('.xls');

                    if (isExcel && window.XLSX) {
                        const reader = new FileReader();
                        reader.onload = (evt) => {
                            try {
                                const data = new Uint8Array(evt.target.result);
                                const workbook = window.XLSX.read(data, { type: 'array' });
                                const firstSheetName = workbook.SheetNames[0];
                                const worksheet = workbook.Sheets[firstSheetName];
                                const csvContent = window.XLSX.utils.sheet_to_csv(worksheet);
                                window.epicheckLastCsvName = fileName;
                                window.epicheckLastCsvContent = csvContent || '';
                            } catch(err) {
                                console.error("Error leyendo archivo Excel:", err);
                            }
                        };
                        reader.readAsArrayBuffer(file);
                    } else {
                        const reader = new FileReader();
                        reader.onload = (evt) => {
                            window.epicheckLastCsvName = fileName;
                            window.epicheckLastCsvContent = evt.target.result || '';
                        };
                        reader.readAsText(file);
                    }
                }
            };
            input.click();
        } catch(e) {
            console.error(e);
        }
    },
    'es.cragma.epicheck.getWasmLastCsvContent' : () => window.epicheckLastCsvContent || '',
    'es.cragma.epicheck.getWasmLastCsvName' : () => window.epicheckLastCsvName || '',
    'es.cragma.epicheck.fetchPostJson_$external_fun' : (p0, p1, p2, isDefault0) => ((url, body, token) => {
        const headers = {'Content-Type': 'application/json'};
        if (token) headers['Authorization'] = 'Bearer ' + token;
        return window.fetch(url, { method: 'POST', headers: headers, body: body })
        .then(res => res.text().then(text => {
            if (!res.ok) {
                var msg = 'Error en la petición POST a Firestore.';
                try {
                    var errObj = JSON.parse(text);
                    var errCode = errObj.error.message;
                    if (errCode === 'INVALID_EMAIL') {
                        msg = 'El correo electrónico no es válido (debe incluir @).';
                    } else if (errCode === 'EMAIL_NOT_FOUND') {
                        msg = 'No existe ninguna cuenta registrada con este correo electrónico.';
                    } else if (errCode === 'INVALID_PASSWORD' || errCode === 'INVALID_LOGIN_CREDENTIALS') {
                        msg = 'La contraseña introducida es incorrecta.';
                    } else if (errCode === 'USER_DISABLED') {
                        msg = 'Esta cuenta de usuario ha sido deshabilitada.';
                    } else if (errCode === 'EMAIL_EXISTS') {
                        msg = 'El correo electrónico ya está registrado por otro usuario.';
                    } else if (errCode) {
                        msg = 'Error Firestore: ' + errCode;
                    }
                } catch(e) {}
                throw new Error(msg);
            }
            return text;
        }));
    })(p0, p1, isDefault0 ? undefined : p2, ),
    'es.cragma.epicheck.fetchPatchJson_$external_fun' : (p0, p1, p2, isDefault0) => ((url, body, token) => {
        const headers = {'Content-Type': 'application/json'};
        if (token) headers['Authorization'] = 'Bearer ' + token;
        return window.fetch(url, { method: 'PATCH', headers: headers, body: body }).then(res => {
            if (!res.ok) {
                return res.text().then(txt => {
                    throw new Error('Error PATCH Firestore (' + res.status + '): ' + txt);
                });
            }
            return res.text();
        });
    })(p0, p1, isDefault0 ? undefined : p2, ),
    'es.cragma.epicheck.jsFetchCompanyUsersFromFirestore_$external_fun' : (p0, p1, p2, isDefault0) => ((projectId, companyId, token) => {
        const url = 'https://firestore.googleapis.com/v1/projects/' + projectId + '/databases/(default)/documents/users?pageSize=300';
        const headers = token ? { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } : { 'Content-Type': 'application/json' };

        return window.fetch(url, { method: 'GET', headers: headers })
            .then(r => r.ok ? r.json() : {})
            .catch(() => ({}))
            .then(data => {
                const docs = (data && data.documents) ? data.documents : [];
                const list = [];
                for (const doc of docs) {
                    const fields = doc.fields || {};
                    const uid = doc.name ? doc.name.split('/').pop() : '';
                    if (!uid) continue;

                    const docCompanyId = fields.companyId ? fields.companyId.stringValue : '';
                    const docCompanyIds = (fields.companyIds && fields.companyIds.arrayValue && fields.companyIds.arrayValue.values)
                        ? fields.companyIds.arrayValue.values.map(v => v.stringValue)
                        : [];

                    const match = !companyId || docCompanyId === companyId || docCompanyIds.includes(companyId);
                    if (match) {
                        const clientIds = (fields.assignedClientCompanyIds && fields.assignedClientCompanyIds.arrayValue && fields.assignedClientCompanyIds.arrayValue.values)
                            ? fields.assignedClientCompanyIds.arrayValue.values.map(v => v.stringValue)
                            : [];
                        const branchIds = (fields.assignedBranchIds && fields.assignedBranchIds.arrayValue && fields.assignedBranchIds.arrayValue.values)
                            ? fields.assignedBranchIds.arrayValue.values.map(v => v.stringValue)
                            : [];

                        list.push({
                            id: uid,
                            name: fields.name ? fields.name.stringValue : '',
                            email: fields.email ? fields.email.stringValue : '',
                            role: fields.role ? fields.role.stringValue : 'Inspector/a',
                            phone: fields.phone ? fields.phone.stringValue : '',
                            position: fields.position ? fields.position.stringValue : '',
                            assignedClientCompanyIds: clientIds,
                            assignedBranchIds: branchIds
                        });
                    }
                }
                return JSON.stringify(list);
            });
    })(p0, p1, isDefault0 ? undefined : p2, ),
    'es.cragma.epicheck.fetchDeleteJson_$external_fun' : (p0, p1, isDefault0) => ((url, token) => {
        const headers = {'Content-Type': 'application/json'};
        if (token) headers['Authorization'] = 'Bearer ' + token;
        return window.fetch(url, { method: 'DELETE', headers: headers }).then(res => {
            if (!res.ok) {
                return res.text().then(txt => {
                    throw new Error('Error DELETE Firestore (' + res.status + '): ' + txt);
                });
            }
            return res.text();
        });
    })(p0, isDefault0 ? undefined : p1, ),
    'es.cragma.epicheck.jsFetchInventoryFromFirestore_$external_fun' : (p0, p1, p2, isDefault0) => ((projectId, companyId, token) => {
        const urlArticulos = 'https://firestore.googleapis.com/v1/projects/' + projectId + '/databases/(default)/documents/articulos?pageSize=300';
        const urlEquipments = 'https://firestore.googleapis.com/v1/projects/' + projectId + '/databases/(default)/documents/equipments?pageSize=300';
        const headers = token ? { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } : { 'Content-Type': 'application/json' };

        return Promise.all([
            window.fetch(urlArticulos, { method: 'GET', headers: headers }).then(r => r.ok ? r.json() : {}).catch(() => ({})),
            window.fetch(urlEquipments, { method: 'GET', headers: headers }).then(r => r.ok ? r.json() : {}).catch(() => ({}))
        ]).then(([data1, data2]) => {
            const docs1 = (data1 && data1.documents) ? data1.documents : [];
            const docs2 = (data2 && data2.documents) ? data2.documents : [];
            const allDocs = [...docs1, ...docs2];
            const list = [];
            const seenIds = new Set();
            for (const doc of allDocs) {
                const fields = doc.fields || {};
                const eqId = doc.name ? doc.name.split('/').pop() : '';
                if (!eqId || seenIds.has(eqId)) continue;
                seenIds.add(eqId);

                const eqCompId = fields.companyId ? fields.companyId.stringValue : '';
                const eqOwner = fields.ownerCompany ? fields.ownerCompany.stringValue : '';

                const history = (fields.inspectionsHistory && fields.inspectionsHistory.arrayValue && fields.inspectionsHistory.arrayValue.values)
                    ? fields.inspectionsHistory.arrayValue.values.map(v => {
                        const hf = (v.mapValue && v.mapValue.fields) ? v.mapValue.fields : {};
                        return {
                            inspectionId: hf.inspectionId ? hf.inspectionId.stringValue : '',
                            date: hf.date ? hf.date.stringValue : '',
                            inspector: hf.inspector ? hf.inspector.stringValue : '',
                            result: hf.result ? hf.result.stringValue : '',
                            observations: hf.observations ? hf.observations.stringValue : '',
                            time: hf.time ? hf.time.stringValue : '12:48'
                        };
                    })
                    : [];

                const item = {
                    id: eqId,
                    companyId: eqCompId,
                    name: fields.name ? fields.name.stringValue : '',
                    serialNumber: fields.serialNumber ? fields.serialNumber.stringValue : '',
                    category: fields.category ? fields.category.stringValue : 'General',
                    manufacturer: fields.manufacturer ? fields.manufacturer.stringValue : '',
                    model: fields.model ? fields.model.stringValue : '',
                    definition: fields.definition ? fields.definition.stringValue : '',
                    size: fields.size ? fields.size.stringValue : 'M',
                    uniqueCode: fields.uniqueCode ? fields.uniqueCode.stringValue : '',
                    digitalId: fields.digitalId ? fields.digitalId.stringValue : '',
                    productionDate: fields.productionDate ? fields.productionDate.stringValue : '',
                    firstUseDate: fields.firstUseDate ? fields.firstUseDate.stringValue : '',
                    assignedInspectionCompany: fields.assignedInspectionCompany ? fields.assignedInspectionCompany.stringValue : 'Próximamente',
                    inspector: fields.inspector ? fields.inspector.stringValue : '',
                    ownerCompany: eqOwner,
                    assignedWorker: fields.assignedWorker ? fields.assignedWorker.stringValue : '',
                    lastInspectionDate: fields.lastInspectionDate ? fields.lastInspectionDate.stringValue : 'Sin inspecciones',
                    nextInspectionDate: fields.nextInspectionDate ? fields.nextInspectionDate.stringValue : '',
                    inspectionId: fields.inspectionId ? fields.inspectionId.stringValue : 'N/A',
                    status: fields.status ? fields.status.stringValue : 'Correcto',
                    registrationDate: fields.registrationDate ? fields.registrationDate.stringValue : '05/10/2026',
                    imageUrl: fields.imageUrl ? fields.imageUrl.stringValue : '',
                    inspectionsHistory: history
                };

                if (!companyId || !item.companyId || item.companyId === companyId || item.companyId === '' || (eqOwner && eqOwner === companyId)) {
                    list.push(item);
                }
            }
            return JSON.stringify(list);
        });
    })(p0, p1, isDefault0 ? undefined : p2, ),
    'es.cragma.epicheck.jsSaveEquipmentToFirestore_$external_fun' : (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14, p15, p16, p17, p18, p19, p20, p21, p22, p23, p24, p25, isDefault0) => ((projectId, docId, compId, name, serialNumber, category, manufacturer, model, definition, size, uniqueCode, digitalId, productionDate, firstUseDate, assignedInspectionCompany, inspector, ownerCompany, assignedWorker, lastInspectionDate, nextInspectionDate, inspectionId, status, registrationDate, historyJson, imageUrl, token) => {
        const fieldsMask = 'updateMask.fieldPaths=companyId&updateMask.fieldPaths=name&updateMask.fieldPaths=serialNumber&updateMask.fieldPaths=category&updateMask.fieldPaths=manufacturer&updateMask.fieldPaths=model&updateMask.fieldPaths=definition&updateMask.fieldPaths=size&updateMask.fieldPaths=uniqueCode&updateMask.fieldPaths=digitalId&updateMask.fieldPaths=productionDate&updateMask.fieldPaths=firstUseDate&updateMask.fieldPaths=assignedInspectionCompany&updateMask.fieldPaths=inspector&updateMask.fieldPaths=ownerCompany&updateMask.fieldPaths=assignedWorker&updateMask.fieldPaths=lastInspectionDate&updateMask.fieldPaths=nextInspectionDate&updateMask.fieldPaths=inspectionId&updateMask.fieldPaths=status&updateMask.fieldPaths=registrationDate&updateMask.fieldPaths=inspectionsHistory&updateMask.fieldPaths=imageUrl';
        const patchUrl1 = 'https://firestore.googleapis.com/v1/projects/' + projectId + '/databases/(default)/documents/articulos/' + docId + '?' + fieldsMask;
        const patchUrl2 = 'https://firestore.googleapis.com/v1/projects/' + projectId + '/databases/(default)/documents/equipments/' + docId + '?' + fieldsMask;
        const postUrl1 = 'https://firestore.googleapis.com/v1/projects/' + projectId + '/databases/(default)/documents/articulos?documentId=' + docId;
        const postUrl2 = 'https://firestore.googleapis.com/v1/projects/' + projectId + '/databases/(default)/documents/equipments?documentId=' + docId;

        let historyValues = [];
        try {
            if (historyJson) {
                const arr = JSON.parse(historyJson);
                if (Array.isArray(arr)) {
                    historyValues = arr.map(h => ({
                        mapValue: {
                            fields: {
                                inspectionId: { stringValue: h.inspectionId || '' },
                                date: { stringValue: h.date || '' },
                                inspector: { stringValue: h.inspector || '' },
                                result: { stringValue: h.result || '' },
                                observations: { stringValue: h.observations || '' },
                                time: { stringValue: h.time || '12:48' }
                            }
                        }
                    }));
                }
            }
        } catch(e) {}

        const body = JSON.stringify({
            fields: {
                companyId: { stringValue: compId || '' },
                name: { stringValue: name || '' },
                serialNumber: { stringValue: serialNumber || '' },
                category: { stringValue: category || 'General' },
                manufacturer: { stringValue: manufacturer || '' },
                model: { stringValue: model || '' },
                definition: { stringValue: definition || '' },
                size: { stringValue: size || 'M' },
                uniqueCode: { stringValue: uniqueCode || '' },
                digitalId: { stringValue: digitalId || '' },
                productionDate: { stringValue: productionDate || '' },
                firstUseDate: { stringValue: firstUseDate || '' },
                assignedInspectionCompany: { stringValue: assignedInspectionCompany || 'Próximamente' },
                inspector: { stringValue: inspector || '' },
                ownerCompany: { stringValue: ownerCompany || '' },
                assignedWorker: { stringValue: assignedWorker || '' },
                lastInspectionDate: { stringValue: lastInspectionDate || 'Sin inspecciones' },
                nextInspectionDate: { stringValue: nextInspectionDate || '' },
                inspectionId: { stringValue: inspectionId || 'N/A' },
                status: { stringValue: status || 'Correcto' },
                registrationDate: { stringValue: registrationDate || '05/10/2026' },
                inspectionsHistory: { arrayValue: { values: historyValues } },
                imageUrl: { stringValue: imageUrl || '' }
            }
        });

        const sendReq = (url, method) => {
            const headers = { 'Content-Type': 'application/json' };
            if (token) {
                headers['Authorization'] = 'Bearer ' + token;
            }
            return window.fetch(url, {
                method: method,
                headers: headers,
                body: body
            }).then(res => {
                if (!res.ok) {
                    return res.text().then(txt => {
                        console.error("Firestore " + method + " failed on " + url + ":", res.status, txt);
                        throw new Error("Firestore " + method + " failed (" + res.status + "): " + txt);
                    });
                }
                return res.text();
            });
        };

        return sendReq(patchUrl1, 'PATCH')
            .catch(() => sendReq(postUrl1, 'POST'))
            .catch(() => sendReq(patchUrl2, 'PATCH'))
            .catch(() => sendReq(postUrl2, 'POST'));
    })(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14, p15, p16, p17, p18, p19, p20, p21, p22, p23, p24, isDefault0 ? undefined : p25, )
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    